


































import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import SaveCancelButtons from '@/components/elements/buttons/save-cancel-buttons.vue';
import { mixins } from 'vue-class-component';
import { validationMixin } from 'vuelidate';
import { Validations } from 'vuelidate-property-decorators';
import { requiredIf } from 'vuelidate/lib/validators';

@Component({
	components: { SaveCancelButtons },
	props: {},
})
export default class ConfirmModal extends mixins(validationMixin) {
	@Prop(String)
	public modalId!: string;
	@Prop(String)
	public modalTitle!: string;
	@Prop(String)
	public modalMessage!: string;
	@Prop({ required: false, type: String, default: 'OK' })
	public okText!: string;
	@Prop({ required: false, type: String, default: 'success' })
	public okVariant!: string;
	@Prop(Boolean)
	public disableOk?: boolean;
	@Prop(String)
	public cancelText?: string;
	@Prop(Array)
	public actionReasons?: string[];

	public actionReason: string | null = null;

	@Validations()
	public validations() {
		return {
			actionReason: {
				requiredIf: requiredIf(() => this.actionReasons && this.actionReasons?.length > 0),
			},
		};
	}

	@Emit('ok')
	public onOk(): { modalId?: string; actionReason?: string | null } {
		return { modalId: this.modalId, actionReason: this.actionReason };
	}

	@Emit('cancel')
	private dismiss(): void {
		this.$bvModal.hide(this.modalId);
	}
}
